import { API } from "../../backend";

export const createaDairy = (userId, token, dairy) => {
  console.log({
    date: dairy.date,
    content: dairy.content,
    title: dairy.title,
  });
  return fetch(`${API}/user/${userId}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      date: dairy.date,
      content: dairy.content,
      title: dairy.title,
    }),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => console.log(err));
};

export const getalldates = (userId, token) => {
  return fetch(`${API}/user/dates/${userId}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => console.log(err));
};

export const getdateDetails = (dairyId, token) => {
  return fetch(`${API}/user/date/${dairyId}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => console.log(err));
};
export const updatedairy = (dairyId, token, dairy) => {
  console.log(dairy);
  return fetch(`${API}/user/date/update/${dairyId}`, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: dairy,
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => console.log(err));
};
